import { projectsCollection, projectGroupCollection } from "../../services/firebase";

const PROJECT_LIST_LIMIT = 200;

export const fetchFilteredProjects = async ({ filterState }) => {
  const clientFilters = filterState.reduce((acc, x) => {
    acc[x.key] = acc[x.key] ? [...acc[x.key], x.value] : [x.value];
    return acc;
  }, {});

  let query = projectsCollection
  .orderBy("id", "desc")

  // Apply filters
  if (clientFilters?.state?.length > 0) {
    query = query.where("state", "in", clientFilters.state);
  }
  if (clientFilters?.lead?.length > 0) {
    query = query.where("projectLead", "in", clientFilters.lead);
  }
  if (clientFilters?.client?.length > 0) {
    query = query.where("client", "in", clientFilters.client);
  }
  if (clientFilters?.group?.length > 0) {
    query = query.where("addToExistingProject", "in", clientFilters.group);
  }
  if (clientFilters?.source?.length > 0) {
    query = query.where("source", "in", clientFilters.source);
  }

  query = query.limit(PROJECT_LIST_LIMIT);

  const snapshot = await query.get();
  return snapshot.docs.map((doc) => ({
    ...doc.data(),
    id: doc.id,
    firestoreId: doc.id,
  }));
};



export const fetchFilteredProjectsGroups = async (filterState) => {
  const clientFilters = filterState?.reduce(
    (acc, x) => {
      if (acc?.[x?.key]) {
        return { ...acc, [x?.key]: [...acc?.[x?.key], x?.value] };
      }
      return { ...acc, [x?.key]: [x?.value] };
    },
    [{}]
  );

  let query = projectGroupCollection

  if (clientFilters?.client?.length > 0)
    query = query.where("client", "in", clientFilters.client);
  if (clientFilters?.lead?.length > 0)
    query = query.where("projectLead", "in", clientFilters.lead);

  const snapshot = await query.get();

  return snapshot.docs.map((doc) => ({
    ...doc.data(),
    id: doc.id,
    firestoreId: doc.id,
  }));
};
